document.addEventListener('DOMContentLoaded', function () {

  const headings = document.querySelectorAll('.footer-v2__heading');

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function applyMenuState(heading, list, mobile) {
    if (mobile) {
      list.classList.add('collapsed');
      heading.classList.remove('active');
    } else {
      list.classList.remove('collapsed');
      heading.classList.add('active');
    }
  }

  function initMobileMenus() {
    const mobile = isMobile();

    headings.forEach(heading => {
      const list = heading.nextElementSibling;

      if (!list || !list.classList.contains('footer-v2__list')) return;

      applyMenuState(heading, list, mobile);

      if (!heading._clickHandler) {
        heading._clickHandler = function () {

          if (isMobile()) {
            list.classList.toggle('collapsed');
            heading.classList.toggle('active');
          }
        };
        heading.addEventListener('click', heading._clickHandler);
      }
    });
  }

  function debounce(fn, delay) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  const handleResize = debounce(function () {
    const mobile = isMobile();

    headings.forEach(heading => {
      const list = heading.nextElementSibling;
      if (list && list.classList.contains('footer-v2__list')) {
        applyMenuState(heading, list, mobile);
      }
    });
  }, 150);

  initMobileMenus();
  window.addEventListener('resize', handleResize);
});